var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77808 8.97951V16.0147C9.81379 16.2826 9.72451 16.5683 9.51917 16.7558C9.43657 16.8385 9.33846 16.9042 9.23046 16.949C9.12245 16.9938 9.00667 17.0169 8.88975 17.0169C8.77282 17.0169 8.65704 16.9938 8.54903 16.949C8.44103 16.9042 8.34292 16.8385 8.26032 16.7558L6.4658 14.9612C6.36843 14.8661 6.29439 14.7496 6.24948 14.6211C6.20456 14.4925 6.18999 14.3553 6.20689 14.2202V8.97951H6.18011L1.0376 2.39067C0.892614 2.20455 0.827195 1.9686 0.855635 1.7344C0.884074 1.50019 1.00406 1.28676 1.18937 1.14075C1.359 1.01576 1.54649 0.944336 1.74291 0.944336H14.2421C14.4385 0.944336 14.626 1.01576 14.7956 1.14075C14.9809 1.28676 15.1009 1.50019 15.1293 1.7344C15.1578 1.9686 15.0924 2.20455 14.9474 2.39067L9.80486 8.97951H9.77808Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFilter);
export default __webpack_public_path__ + "static/media/blackFilter.c8e0b39a397eedf89b063876976faeec.svg";
export { ForwardRef as ReactComponent };